export const NAMES = {
  PASSPORT_SERIA_NUMBER: 'serianumber',
  PASSPORT_SERIES: 'series',
  PASSPORT_NUMBER: 'number',
  PASSPORT_ISSUE_DATE: 'issueDate',
  PASSPORT_ISSUER_CODE: 'issuerCode',
  PASSPORT_ISSUER: 'issuer',
  BIRTH_PLACE: 'birthPlace',
  BIRTHDAY_DATE: 'birthDate',
  PERSON_GENDER: 'gender',
};

export const PASSPORT_FORM_LABELS = {
  [NAMES.PASSPORT_SERIA_NUMBER]: 'Серия, номер',
  [NAMES.PASSPORT_ISSUE_DATE]: 'Дата выдачи',
  [NAMES.PASSPORT_ISSUER_CODE]: 'Код подразделения',
  [NAMES.PASSPORT_ISSUER]: 'Кем выдано',
  [NAMES.BIRTH_PLACE]: 'Место рождения',
  [NAMES.BIRTHDAY_DATE]: 'Дата рождения',
};
